import conventionalBoxImg from '../../../assets/bhutani/Conventional/conventionalBox.jpg'
import officeBoxImg from '../../../assets/bhutani/Office/officeBox.jpg'
import wellnessBoxImg from '../../../assets/bhutani/Wellness/wellnessBox.jpg'
import studioBoxImg from '../../../assets/bhutani/Studio/studioBox.webp'
import foodCourtBoxImg from '../../../assets/bhutani/Food/foodCourtBox.jpg'
import restaurantBoxImg from '../../../assets/bhutani/Restaurants/restaurantBox.jpeg'

export const bhutaniCCData = [
    {
        id: 0,
        title: "Bhutani Grand Conventional Center",
        route: "bhutani-city-center/conventional-center",
        imgUri: conventionalBoxImg,
    },
    {
        id: 1,
        title: "Lockable Green Offices",
        route: "bhutani-city-center/green-office",
        imgUri: officeBoxImg,
    },
    {
        id: 2,
        title: "Bhutani Wellness",
        route: "bhutani-city-center/wellness",
        imgUri: wellnessBoxImg,
    },
    {
        id: 3,
        title: "Studio Apartments",
        route: "bhutani-city-center/apartments",
        imgUri: studioBoxImg,
    },
    {
        id: 4,
        title: "Food Courts (PVR Superplex)",
        imgUri: foodCourtBoxImg,
        route: "bhutani-city-center/food-court",
    },
    {
        id: 5,
        title: "Restaurants & Fine Dining",
        route: "bhutani-city-center/restaurants",
        imgUri: restaurantBoxImg,
    },
]